"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_device_detect_1 = require("react-device-detect");
var deviceInfo = {
    deviceType: {
        isMobile: react_device_detect_1.isMobile,
        isTablet: react_device_detect_1.isTablet,
        isDesktop: react_device_detect_1.isDesktop
    },
    operatingSystem: {
        osName: react_device_detect_1.osName,
        osVersion: react_device_detect_1.osVersion
    },
    browser: {
        browserName: react_device_detect_1.browserName,
        browserVersion: react_device_detect_1.browserVersion
    },
    deviceSpecific: {
        isIPad13: react_device_detect_1.isIPad13,
        isIPhone13: react_device_detect_1.isIPhone13,
        isAndroid: react_device_detect_1.isAndroid,
        isWindows: react_device_detect_1.isWindows,
        isMacOs: react_device_detect_1.isMacOs,
        isMobileOnly: react_device_detect_1.isMobileOnly
    },
    browserSpecific: {
        isMobileSafari: react_device_detect_1.isMobileSafari,
        isChrome: react_device_detect_1.isChrome,
        isFirefox: react_device_detect_1.isFirefox,
        isSafari: react_device_detect_1.isSafari,
        isIE: react_device_detect_1.isIE,
        isEdge: react_device_detect_1.isEdge
    }
};
exports.default = deviceInfo;
